import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { cdvFaqs } from '../../data/academiaCdv';
export function CdvFaq() {
  const [open, setOpen] = useState<number | null>(0);
  return <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-31" data-mp="2hulqobqghuik">
      {cdvFaqs.map((faq, i) => {
      const isOpen = open === i;
      return <li key={faq.question} data-id="element-32" data-mp="1q6jzt7325iqt" data-mpi={i}>
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`cdv-faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:text-gold-metallic" data-id="element-33" data-mp="1q7d5s5u7047w">
              <span className="text-base md:text-lg font-semibold text-white" data-id="element-34" data-mp="16i2t70pqtze0">
                {faq.question}
              </span>
              <PlusIcon className={`h-5 w-5 flex-shrink-0 text-gold-metallic transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-35" data-mp="1bfbcj4mmo9gu" />
            </button>
            <AnimatePresence initial={false} data-id="element-36" data-mp="37oqhufkn2epi">
              {isOpen && <motion.div id={`cdv-faq-${i}`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-37" data-mp="32ttb5fau0hfs">
                  <p className="pb-5 pr-8 text-white/70 leading-relaxed" data-id="element-38" data-mp="2jxtfnuinavrg">
                    {faq.answer}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}